/* ============================================
   DIGITAL HERBALIST AI ENGINE
============================================ */

const symptomMap = {

circulation:["hawthorn","hibiscus","garlic","ginger","yarrow","ginkgo"],

digestion:["ginger","fennel","peppermint","gentian","catnip"],

stress:["ashwagandha","holy_basil","lemon_balm","rhodiola"],

sleep:["valerian","passionflower","skullcap","chamomile","lemon_balm"],

immune:["elderberry","echinacea","astragalus","oregano","ginger"],

inflammation:["turmeric","ginger","boswellia","willow_bark"],

respiratory:["mullein","thyme","marshmallow_root","oregano"]

};


const formulaRatios = {

primary:40,
support:30,
enhancer:20,
balancer:10

};


/* ---------- Load symptoms ---------- */

function loadSymptoms(){

const grid = document.getElementById("symptom-grid");

if(!grid) return;

Object.keys(symptomMap).forEach(symptom=>{

const btn=document.createElement("button");

btn.innerText=symptom;

btn.className="symptom-btn";

btn.onclick=()=>btn.classList.toggle("active");

grid.appendChild(btn);

});

}


/* ---------- Get selected symptoms ---------- */

function getSelectedSymptoms(){

const active=document.querySelectorAll(".symptom-btn.active");

const list=[];

active.forEach(btn=>list.push(btn.innerText));

return list;

}


/* ---------- Recommend herbs ---------- */

function recommendHerbs(symptoms){

const scores={};

symptoms.forEach(symptom=>{

(symptomMap[symptom]||[]).forEach(herb=>{

scores[herb]=(scores[herb]||0)+1;

});

});

return Object.keys(scores).sort((a,b)=>scores[b]-scores[a]);

}


/* ---------- Build formula ---------- */

function buildFormula(){

const symptoms=getSelectedSymptoms();

const recommended=recommendHerbs(symptoms);

const primary=recommended.find(h=>herbDatabase[h]?.role==="primary");

const support=recommended.filter(h=>herbDatabase[h]?.role==="support").slice(0,2);

const enhancer=recommended.find(h=>herbDatabase[h]?.role==="enhancer");

const formula={primary,support,enhancer};

checkInteractions(formula);

renderFormula(formula);

}


/* ---------- Interaction warnings ---------- */

function checkInteractions(formula){

let warnings=[];

Object.values(formula).flat().forEach(h=>{

const herb=herbDatabase[h];

if(herb?.contra){

warnings.push(`${herb.name} may interact with ${herb.contra.join(", ")}`);

}

});

if(warnings.length){

alert("Safety Notice:\n"+warnings.join("\n"));

}

}


/* ---------- Render formula ---------- */

function renderFormula(formula){

const result=document.getElementById("formula-result");

if(!result) return;

result.innerHTML="";

if(formula.primary){

result.innerHTML+=`<h3>Primary Herb (40%)</h3><p>${herbDatabase[formula.primary].name}</p>`;

}

if(formula.support.length){

result.innerHTML+="<h3>Supporting Herbs (30%)</h3>";

formula.support.forEach(h=>{

result.innerHTML+=`<p>${herbDatabase[h].name}</p>`;

});

}

if(formula.enhancer){

result.innerHTML+=`<h3>Enhancer (20%)</h3><p>${herbDatabase[formula.enhancer].name}</p>`;

}

}


/* ---------- DOM Ready ---------- */

document.addEventListener("DOMContentLoaded",()=>{

loadSymptoms();

const analyzeBtn=document.getElementById("analyze-btn");

if(analyzeBtn){

analyzeBtn.addEventListener("click",buildFormula);

}

});